import type { VoidFunctionComponent } from 'react';

import { useOrganizationPackageLabels } from '../../../hooks/api/packageLabels';
import { Select } from '../../generic';
import type { SelectOption } from '../../../types';

import styles from './PackageLabelOptions.module.less';

type PackageLabelOptionsProps = {
  setIsEnabled: (isEnabled: boolean) => void;
  packageLabels: SelectOption[];
  setPackageLabels: (labels: SelectOption[]) => void;
};

const PackageLabelOptions: VoidFunctionComponent<PackageLabelOptionsProps> = ({
  setIsEnabled,
  packageLabels,
  setPackageLabels,
}) => {
  const { data: labels, isLoading: isLoadingLabels } = useOrganizationPackageLabels();

  return (
    <div className={styles.packageLabelContainer}>
      <span className={styles.packageLabelText}>
        If the dependency has Package Labels assigned
      </span>
      {!isLoadingLabels && (
        <Select
          id="issue-exception-modal-package-labels-select"
          isMulti
          placeholder="Select package labels..."
          value={packageLabels}
          onChange={(options) => {
            setPackageLabels(options);
            setIsEnabled(true);
          }}
          options={(labels?.packageLabels || []).map((label) => ({
            label: label.name,
            value: label.id.toString(),
          }))}
          className={styles.packageLabelOptionsSelect}
        />
      )}
    </div>
  );
};

export default PackageLabelOptions;
